import React, { useEffect } from "react";
import withRouter from "components/Common/withRouter";
import { del } from "../../helpers/api_helper";
//redux
import { useNavigate, useParams } from "react-router-dom";
import { REMOVE_USER } from "helpers/api_endpoints";

const RemoveUser = () => {
    const history = useNavigate();
    const params = useParams();
    const id = params.id;

    useEffect(() => {
        del(REMOVE_USER, { id })
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error);
            })
    });

    return <></>;
};

export default withRouter(RemoveUser);